import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { Vector2, NormalBlending } from "three";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass";
/**
 * Manager for managing three.js event display effects like outline pass and unreal bloom.
 */
var EffectsManager = /** @class */ (function () {
    /**
     * Constructor for the effects manager which manages effects and three.js passes.
     * @param camera The camera inside the scene.
     * @param scene The default scene used for event display.
     * @param renderer The main renderer used by the event display.
     */
    function EffectsManager(camera, scene, renderer) {
        this.composer = new EffectComposer(renderer);
        this.camera = camera;
        this.scene = scene;
        this.defaultRenderPass = new RenderPass(this.scene, this.camera);
        this.composer.addPass(this.defaultRenderPass);
    }
    /**
     * Render the effects composer.
     * @param camera The camera inside the scene.
     * @param scene The default scene used for event display.
     */
    EffectsManager.prototype.render = function (camera, scene) {
        if (this.composer) {
            this.defaultRenderPass.camera = camera;
            this.defaultRenderPass.scene = scene;
            this.composer.render();
        }
    };
    /**
     * Initialize the outline pass for highlighting hovered over event display elements.
     * @returns OutlinePass for highlighting hovered over event display elements.
     */
    EffectsManager.prototype.addOutlinePassForSelection = function () {
        var outlinePass = new OutlinePass(new Vector2(window.innerWidth, window.innerHeight), this.scene, this.camera);
        outlinePass.overlayMaterial.blending = NormalBlending;
        outlinePass.visibleEdgeColor.set(0xffff66);
        outlinePass.visibleEdgeColor.set(0xdf5330);
        this.composer.addPass(outlinePass);
        return outlinePass;
    };
    /**
     * Remove a pass from the effect composer.
     * @param pass Effect pass to be removed from the effect composer.
     */
    EffectsManager.prototype.removePass = function (pass) {
        var passIndex = this.composer.passes.indexOf(pass);
        this.composer.passes.splice(passIndex, 1);
    };
    return EffectsManager;
}());
export { EffectsManager };
//# sourceMappingURL=effects-manager.js.map